<template>
  <div class="popup__block">
    <div class="popup__close"></div>
    <div class="popup__title">Покупка в 1 клик</div>
    <div class="popup-quick">
      <form @submit.prevent="debounce(validate)" class="form">
        <div class="form__inputs">
          <div class="default-input">
            <input @input="this.reset" class="default-input__input" v-model="personalData.FIO.value" v-bind:class="{'default-input__input--error':errors.some(er => parseInt(er.code) === 1)}" type="text" placeholder="ФИО">
            <span v-if="errors.some(er => parseInt(er.code) === 1)" class="default-input__error"></span>
          </div>
          <div class="default-input">
            <input @input="this.reset" class="default-input__input" v-model="personalData.PHONE.value" v-bind:class="{'default-input__input--error':errors.some(er => parseInt(er.code) === 3)}" type="text" inputmode="numeric" placeholder="Телефон" data-mask-phone>
            <span v-if="errors.some(er => parseInt(er.code) === 3)" class="default-input__error"></span>
          </div>
          <div class="default-input">
            <input @input="this.reset" class="default-input__input" v-model="personalData.EMAIL.value" v-bind:class="{'default-input__input--error':errors.some(er => parseInt(er.code) === 2)}" type="text" placeholder="E-mail">
            <span v-if="errors.some(er => parseInt(er.code) === 2)" class="default-input__error"></span>
          </div>
        </div>
        <div style="display: none">
          <vue-recaptcha ref="recaptcha" size="invisible" :sitekey="this.site_key" @verify="validateFields" @expired="onCaptchaExpired"/>
        </div>
        <div class="form__submit">
          <button @click.prevent="debounce(validate)" class="form__submit-btn btn btn--mini">Оформить заказ</button>
          <div class="form__submit-text">Нажимая кнопку, Вы даете информированное согласие на
            <a target="_blanc" :href="modulePolicy.file_src">обработку своих персональных данных</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import recaptcha  from "@/components/mixins/recaptcha";
import errors     from "@/components/mixins/errors";
import tools      from "@/components/mixins/tools";
import {mapState} from "vuex";
import { reachGoal as ymReachGoal } from "@/modules/metrika";

export default {

  name  : "QuickOrderForm",
  props : {
    fio_prop   : String,
    phone_prop : String,
    email_prop : String
  },
  data()
  {
    return {
      propNames : {
        FIO                : "ORDER_PROP_1",
        EMAIL              : "ORDER_PROP_2",
        PHONE              : "ORDER_PROP_3",
        CITY               : "ORDER_PROP_5",
        LOCATION           : "ORDER_PROP_6",
        ADDRESS            : "ORDER_PROP_7",
        DELIVERY_DATE      : "ORDER_PROP_20",
        DELIVERY_TIME_CHEL : "ORDER_PROP_21",
        CALL_BACK          : "ORDER_PROP_22",
        FIO_BILL           : "ORDER_PROP_24",
        PHONE_BILL         : "ORDER_PROP_25",
        EMAIL_BILL         : "ORDER_PROP_26",
        ACCOUNT_INFO       : "ORDER_PROP_27",
        STREET             : "ORDER_PROP_32",
        HOUSE              : "ORDER_PROP_33",
        ENTRANCE           : "ORDER_PROP_34",
        APARTMENT          : "ORDER_PROP_35",
        DELIVERY_TIME_DPD  : "ORDER_PROP_36",
        COMMENT            : "ORDER_DESCRIPTION",
        QUICK_ORDER        : "ORDER_PROP_37"
      },

      personalData : {
        FIO   : {
          value : "",
          title : "ФИО",
          code  : "1"
        },
        PHONE : {
          value : "",
          title : "Телефон",
          code  : "2"
        },
        EMAIL : {
          value : "",
          title : "Е-mail",
          code  : "3"
        }
      },

      personalExtra : {
        PERSON_TYPE : "individual",
        CALL_BACK   : "Y",
        QUICK_ORDER : "Y"
      }
    };
  },
  computed : {
    ...mapState([
      "modulePolicy"
    ])
  },
  mixins   : [recaptcha, errors, tools],
  methods  : {
    makeFormData()
    {
      let formData = new FormData();
      for(let key in this.personalData)
        formData.set(this.propNames[key] ? this.propNames[key] : key, this.personalData[key].value);
      for(let key in this.personalExtra)
        formData.set(this.propNames[key] ? this.propNames[key] : key, this.personalExtra[key]);
      return formData;
    },
    validateFields( recaptchaToken )
    {
      this.reset();
      let formData = this.makeFormData();
      formData.append("token", recaptchaToken);
      fetch("/api/orders/quick_order/make/", {
        method : "POST",
        body   : formData
      })
      .then(response => response.json())
      .then(result =>
      {
        if(result.data)
        {
          if(result.data.orderId)
          {
            ymReachGoal('click_order');
            window.location.href = "/personal/order/?ORDER_ID=" + result.data.orderId;
          }
        }
        else
        {
          let errs = JSON.parse(result.message);
          this.parse(errs);
        }
      });
    }
  },
  created()
  {
    this.personalData.FIO.value   = this.fio_prop;
    this.personalData.EMAIL.value = this.email_prop;
    this.personalData.PHONE.value = this.phone_prop;
  }
};
</script>

<style scoped>

</style>
